<template>
  <div>
    <FacePhraseForIndexPage
      v-if="coupons.length == 0"
      phrase="クーポンはありません​"
    />

    <TheCouponsIndex v-else />
  </div>
</template>

<script>
import { computed } from "vue";
import { useStore } from "vuex";

export default {
  name: "TemplateMyCouponsIndexOfPast",
  setup() {
    const store = useStore();
    const coupons = computed(() => store.getters["coupon/externalCoupons"]);

    return {
      coupons,
    };
  },
};
</script>
